import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Signal,
    effect,
    inject,
    viewChild,
} from "@angular/core";
import { TargetGroupsStore } from "../../../stores/target-groups/target-groups.store";
import { ComponentRoutes } from "../../../models/constants/component-routes";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { TargetGroupViewModel } from "@playcharge/common/models/backend/target-groups/target-group-view-model";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatCheckbox } from "@angular/material/checkbox";
import { RouterLink } from "@angular/router";
import { MatMenuModule } from "@angular/material/menu";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-target-groups",
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatSortModule,
        MatFormField,
        MatLabel,
        MatInput,
        MatIcon,
        MatCheckbox,
        MatMenuModule,
        MatButton,
        RouterLink,
    ],
    templateUrl: "./target-groups.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TargetGroupsComponent {
    public targetGroupsStore = inject(TargetGroupsStore);

    private _matSort: Signal<MatSort | undefined> = viewChild(MatSort);

    public displayedColumns: string[] = ["name", "actions"];
    public dataSource: MatTableDataSource<TargetGroupViewModel> =
        new MatTableDataSource<TargetGroupViewModel>();

    public ComponentRoutes: typeof ComponentRoutes = ComponentRoutes;

    constructor() {
        effect(() => {
            if (this._matSort()) {
                this.dataSource.sort = this._matSort()!;
            }
        });

        effect(() => {
            this.dataSource.data = this.targetGroupsStore.entities();
        });
    }

    public ngAfterViewInit(): void {
        this.dataSource.filterPredicate = this.filterPredicate;
    }

    public applyFilter(event: KeyboardEvent): void {
        this.dataSource.filter = (event.target as HTMLInputElement).value;
    }

    private filterPredicate(targetGroup: TargetGroupViewModel, filter: string): boolean {
        return (
            targetGroup.name?.trim().toLocaleLowerCase().includes(filter.trim().toLowerCase()) ??
            false
        );
    }
}
